import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { ResponsiveStream } from '@nivo/stream'
import { useChartData } from '../hooks/useChartData'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const StreamChart = () => {
  const theme = useStatsTheme((s) => s.theme)
  const { data, monthLabels, genres, genreColors } = useChartData()

  return (
    <ResponsiveStream
      data={data}
      colors={({ id }) => genreColors[id] || theme.colors.section.bgSecondary}
      curve="linear"
      keys={genres as any}
      margin={{ left: 10, top: 5, bottom: 20, right: 10 }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        renderTick: (tick) => (
          <g transform={`translate(${tick.x},${tick.y + 10})`}>
            <foreignObject width={30} height={30} x={-15} y={-11.5}>
              <FlexBox
                className={css`
                  padding-top: 5px;
                  gap: 6px;
                `}
                flexDirection="column"
                alignItems="center"
              >
                <span
                  className={css`
                    display: block;
                    width: 1px;
                    height: 2px;
                    background-color: ${theme.colors.section.textSecondary};
                  `}
                />
                <Text
                  type="body"
                  className={css`
                    font-size: 8px;
                    line-height: 8px;
                  `}
                  color={theme.colors.section.textSecondary}
                  align="center"
                >
                  {monthLabels[tick.value]}
                </Text>
              </FlexBox>
            </foreignObject>
          </g>
        ),
      }}
      animate={false}
      axisLeft={null}
      enableGridX={true}
      enableGridY={false}
      offsetType="silhouette"
      legends={[]}
      valueFormat={(value) => `${value} books`}
      isInteractive={false}
      theme={{
        grid: {
          line: {
            stroke: theme.colors.section.chart.lines,
            strokeDasharray: '2 4',
          },
        },
      }}
    />
  )
}
